<template>
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-center py-3 gap-3">
    <!-- Info count -->
    <div class="text-muted small">
      {{ $t('common.showing') }} <span class="text-white font-weight-medium">{{ fromItem }}</span> {{ $t('common.to') }}
      <span class="text-white font-weight-medium">{{ toItem }}</span> {{ $t('common.of') }}
      <span class="text-white font-weight-medium">{{ totalItems }}</span> {{ $t('common.entries') }}
    </div>

    <!-- Pagination controls -->
    <nav aria-label="Page navigation" v-if="totalPages > 1">
      <ul class="pagination pagination-sm m-0 align-items-center">
        <!-- Previous -->
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button
            class="page-link"
            type="button"
            @click="prevPage"
            :disabled="currentPage === 1"
            :title="$t('common.previous')"
          >
            <i class="mdi mdi-chevron-left mr-1"></i>
            <span class="d-none d-sm-inline">{{ $t('common.previous') }}</span>
          </button>
        </li>

        <!-- First page if far -->
        <li v-if="startPage > 1" class="page-item">
          <button class="page-link" type="button" @click="changePage(1)">1</button>
        </li>
        <li v-if="startPage > 2" class="page-item disabled">
          <span class="page-link border-0 bg-transparent text-muted">···</span>
        </li>

        <!-- Page numbers -->
        <li
          v-for="page in pagesToShow"
          :key="page"
          class="page-item"
          :class="{ active: currentPage === page }"
        >
          <button
            class="page-link"
            type="button"
            @click="changePage(page)"
          >
            {{ page }}
          </button>
        </li>

        <!-- Last page if far -->
        <li v-if="endPage < totalPages - 1" class="page-item disabled">
          <span class="page-link border-0 bg-transparent text-muted">···</span>
        </li>
        <li v-if="endPage < totalPages" class="page-item">
          <button class="page-link" type="button" @click="changePage(totalPages)">{{ totalPages }}</button>
        </li>

        <!-- Next -->
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button
            class="page-link"
            type="button"
            @click="nextPage"
            :disabled="currentPage === totalPages"
            :title="$t('common.next')"
          >
            <span class="d-none d-sm-inline">{{ $t('common.next') }}</span>
            <i class="mdi mdi-chevron-right ml-1"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'PaginationComponents',
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    maxPagesToShow: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalItems / this.itemsPerPage));
    },
    fromItem() {
      if (this.totalItems === 0) return 0;
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    toItem() {
      return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
    },
    startPage() {
      const half = Math.floor(this.maxPagesToShow / 2);
      if (this.currentPage <= half) {
        return 1;
      } else if (this.currentPage + half >= this.totalPages) {
        return Math.max(1, this.totalPages - this.maxPagesToShow + 1);
      } else {
        return this.currentPage - half;
      }
    },
    endPage() {
      return Math.min(this.startPage + this.maxPagesToShow - 1, this.totalPages);
    },
    pagesToShow() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    changePage(page) {
      if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
        this.$emit('page-changed', page);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.$emit('page-changed', this.currentPage - 1);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit('page-changed', this.currentPage + 1);
      }
    },
  },
};
</script>